import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { AnalyticsDevFlagsHttpClient } from './analytics-dev-flags.http';
import { AnalyticsDevFlagsActions } from './analytics-dev-flags.store';

@Injectable()
export class AnalyticsDevFlagsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(AnalyticsDevFlagsHttpClient);

  public effects = createEffectFactory(AnalyticsDevFlagsActions, this.actions$);

  public fetch$ = this.effects(AnalyticsDevFlagsActions.fetch, () => this.http.fetch());
}
